import { Lock, LockOpen } from "lucide-react";

/**
 * Indicador visual de acceso al módulo (esquina superior derecha de tarjetas hub).
 */
export default function ModuleAccessLockIcon({ hasModuleAccess, loading, className = "top-4 right-4" }) {
  const base = `absolute w-4 h-4 ${className}`.trim();

  if (loading) {
    return (
      <Lock
        className={`${base} text-slate-300 animate-pulse`}
        aria-hidden
        data-testid="module-access-lock-loading"
      />
    );
  }

  if (hasModuleAccess) {
    return (
      <LockOpen
        className={`${base} text-[#3DA873]`}
        aria-label="Módulo incluido en su plan"
        data-testid="module-access-lock-open"
      />
    );
  }

  return (
    <Lock
      className={`${base} text-slate-400`}
      aria-label="Módulo no incluido en su plan"
      data-testid="module-access-lock-closed"
    />
  );
}
